import { useQueryClient } from "react-query";
import Info from "assets/images/svg/info_dark.svg";
import Countdown from "react-countdown";
import React from "react";

export function CounterInfoComponent({
  date,
  message = "Check your mailbox to confirm your e-mail expires in",
  queryKey = "emails-data",
  onEnded,
  onStart
}: {
  date?: string;
  message?: string;
  queryKey?: string;
  onEnded?: () => void;
  onStart?: () => void;
}) {
  const queryClient = useQueryClient();
  return (
    <div className="info">
      <img src={Info} alt="info" />
      <p>
        {message} {/*@ts-ignore */}
        <Countdown
          onStart={() => {
            onStart?.();
          }}
          onComplete={() => {
            onEnded?.();
            queryClient.invalidateQueries(queryKey);
          }}
          date={date}
          renderer={(p) => (
            <span>
              {p.formatted.minutes}:{p.formatted.seconds}
            </span>
          )}
        />
      </p>
    </div>
  );
}
